import Vue from 'vue'
import axios from '../../axios'
import router from '../../router'

// initial state
const state = {
  active: 0,
  navs: []
}

// getters
const getters = {}

// actions
const actions = {
  menuIndex(context) {
    if (state.active === 0) {
      state.active = localStorage.getItem('active')
    }
    axios.get('menu/list', {
      params: {
        categoryFlag: 'dh',
        displayAreas: '网站',
        pageNo: 1,
        pageSize: 100
      }
    }).then((res) => {
      if (res.data.code == 200) {
        let arr = []
        res.data.data.forEach((item) => {
          router.addRoute({
            path: item.fileUrl,
            name: item.name,
            component: () => import('@/' + item.fileUrl)
          })
        })
        // sessionStorage.setItem('menus', JSON.stringify(item.name))
        // (arr)
        context.commit('setnav', res.data.data)
      }
    })
  }
}

// mutations
const mutations = {
  setactive(state, data) {
    state.active = data
    localStorage.setItem('active', data)
  },
  setnav(state, data) {
    state.navs = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js